import React, { useEffect, useState } from 'react';
import * as S from './styles';
import Header from '../../componentes/Header/index';
import Footer from '../../componentes/Footer/index';
import BarraLateral from '../../componentes/BarraLateral';
import api from '../../services/api';
import { Ativacao, BuscarTemplates } from './modal';

import logo_bg from '../../midia/app_autoboox.jpg';

export default function Autoboox() {
  const PRODUTO_IMAGEM_PUBLICA_CACHE_KEY = 'autoboox_produto_imagem_publica';

  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState('ativacao');
  const [loading, setLoading] = useState(false);
  const [editandoConexao, setEditandoConexao] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [integrationStatus, setIntegrationStatus] = useState({
    ativo: false,
    conectado: false,
    testeEnvioConcluido: false,
    configurado: false
  });
  const [form, setForm] = useState({
    appId: '',
    appSecret: '',
    businessAccountId: '',
    templatesWabaId: '',
    phoneNumberId: '',
    systemUserAccessToken: '',
    webhookVerifyToken: '',
    webhookPath: '/webhooks/whatsapp/meta'
  });
  const [consultaTemplatesLoading, setConsultaTemplatesLoading] = useState(false);
  const [consultaTemplatesMessage, setConsultaTemplatesMessage] = useState({ type: '', text: '' });
  const [consultaTemplates, setConsultaTemplates] = useState([]);
  const [consultaTemplatesForm, setConsultaTemplatesForm] = useState(() => {
    let imagemPublica = '';

    try {
      imagemPublica = String(localStorage.getItem(PRODUTO_IMAGEM_PUBLICA_CACHE_KEY) || '');
    } catch (erro) {
      imagemPublica = '';
    }

    return {
      wabaId: '',
      limit: '200',
      selectedTemplateKey: '',
      to: '',
      bodyParams: '',
      orderReferenceId: '',
      orderTotalAmount: '',
      orderPaymentLink: '',
      orderType: 'digital-goods',
      orderNumber: '',
      productName: '',
      productQuantity: '',
      productImagePublicUrl: imagemPublica
    };
  });
  const [envioTemplateLoading, setEnvioTemplateLoading] = useState(false);
  const [envioTemplateMessage, setEnvioTemplateMessage] = useState({ type: '', text: '' });

  const etapa2Liberada = integrationStatus.ativo && integrationStatus.conectado;

  const webhookUrl = `${api.defaults.baseURL}${form.webhookPath}`;

  function gerarToken(tamanho = 32) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let token = '';

    for (let i = 0; i < tamanho; i += 1) {
      token += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return token;
  }

  async function handleOpenModal() {
    setShowWhatsappModal(true);
    const status = await carregarStatus();

    if (status?.ativo) {
      await carregarConfiguracaoAtual();
    }
  }

  function handleCloseModal() {
    setShowWhatsappModal(false);
    setEditandoConexao(false);
    setMessage({ type: '', text: '' });
  }

  function abrirModalNaAba(tabKey) {
    setActiveModalTab(tabKey);
    if (!showWhatsappModal) {
      handleOpenModal();
    }
  }

  function handleChangeField(campo, valor) {
    setForm((prev) => ({ ...prev, [campo]: valor }));
  }

  function validarFormulario() {
    const obrigatorios = [
      'appId',
      'appSecret',
      'businessAccountId',
      'phoneNumberId',
      'systemUserAccessToken',
      'webhookVerifyToken'
    ];

    const campoVazio = obrigatorios.find((campo) => !form[campo]?.trim());
    if (campoVazio) {
      setMessage({ type: 'error', text: 'Preencha todos os campos obrigatorios antes de salvar.' });
      return false;
    }

    return true;
  }

  function normalizarErro(erro, fallback) {
    return erro?.response?.data?.message || erro?.response?.data?.erro || fallback;
  }

  function handleConsultaTemplatesField(campo, valor) {
    setConsultaTemplatesForm((prev) => ({ ...prev, [campo]: valor }));
  }

  function montarParametrosParaEnvio(totalEsperado, hasOrderDetailsButton) {
    const paramsBase = String(consultaTemplatesForm.bodyParams || '')
      .split('|')
      .map((item) => item.trim())
      .filter(Boolean);

    if (!hasOrderDetailsButton) {
      return paramsBase;
    }

    const candidatosFallback = [
      String(consultaTemplatesForm.orderNumber || '').trim(),
      String(consultaTemplatesForm.productName || '').trim(),
      String(consultaTemplatesForm.productQuantity || '').trim(),
      String(consultaTemplatesForm.orderTotalAmount || '').trim(),
      String(consultaTemplatesForm.orderReferenceId || '').trim()
    ].filter(Boolean);

    const paramsComFallback = [...paramsBase];

    while (paramsComFallback.length < Number(totalEsperado || 0) && candidatosFallback.length > 0) {
      paramsComFallback.push(candidatosFallback.shift());
    }

    return paramsComFallback;
  }

  function contarVariaveisNoTexto(texto) {
    const conteudo = String(texto || '');
    const matches = [...conteudo.matchAll(/\{\{\s*([^{}]+?)\s*\}\}/g)];
    if (!matches.length) {
      return 0;
    }

    const tokens = matches.map((item) => String(item?.[1] || '').trim()).filter(Boolean);
    const todosNumericos = tokens.length > 0 && tokens.every((token) => /^\d+$/.test(token));

    if (todosNumericos) {
      return tokens.reduce((maior, token) => Math.max(maior, Number(token)), 0);
    }

    // Para placeholders nomeados (ex.: {{nome}}), usa quantidade unica em ordem de aparicao.
    return new Set(tokens).size;
  }

  function extrairTokensTemplate(texto, quantidadeEsperada) {
    const conteudo = String(texto || '');
    const matches = [...conteudo.matchAll(/\{\{\s*([^{}]+?)\s*\}\}/g)];
    const tokens = matches.map((item) => String(item?.[1] || '').trim()).filter(Boolean);

    if (!tokens.length) {
      return [];
    }

    const todosNumericos = tokens.every((token) => /^\d+$/.test(token));
    if (todosNumericos) {
      const maiorIndice = tokens.reduce((maior, token) => Math.max(maior, Number(token)), 0);
      return Array.from({ length: maiorIndice }, (_, index) => String(index + 1));
    }

    const unicosOrdenados = [];
    tokens.forEach((token) => {
      if (!unicosOrdenados.includes(token)) {
        unicosOrdenados.push(token);
      }
    });

    const qtd = Math.max(0, Number(quantidadeEsperada || 0));
    return qtd > 0 ? unicosOrdenados.slice(0, qtd) : unicosOrdenados;
  }

  function obterValorParametroNomeado(token) {
    const chave = String(token || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');

    if (!chave) {
      return '';
    }

    const dicionario = {
      order_number: String(consultaTemplatesForm.orderNumber || '').trim(),
      order_no: String(consultaTemplatesForm.orderNumber || '').trim(),
      order_id: String(consultaTemplatesForm.orderNumber || '').trim(),
      charge: String(consultaTemplatesForm.orderNumber || '').trim(),
      product_name: String(consultaTemplatesForm.productName || '').trim(),
      item_name: String(consultaTemplatesForm.productName || '').trim(),
      description: String(consultaTemplatesForm.productName || '').trim(),
      quantity: String(consultaTemplatesForm.productQuantity || '').trim(),
      qty: String(consultaTemplatesForm.productQuantity || '').trim(),
      total: String(consultaTemplatesForm.orderTotalAmount || '').trim(),
      total_amount: String(consultaTemplatesForm.orderTotalAmount || '').trim(),
      amount: String(consultaTemplatesForm.orderTotalAmount || '').trim(),
      reference_id: String(consultaTemplatesForm.orderReferenceId || '').trim(),
      reference: String(consultaTemplatesForm.orderReferenceId || '').trim()
    };

    return String(dicionario[chave] || '').trim();
  }

  function obterQuantidadePorExample(component, type) {
    const example = component?.example || {};

    if (type === 'HEADER') {
      const headerText = example?.header_text;

      if (Array.isArray(headerText)) {
        return headerText.reduce((maior, item) => Math.max(maior, Array.isArray(item) ? item.length : 0), 0);
      }

      return 0;
    }

    if (type === 'BODY') {
      const bodyText = example?.body_text;

      if (Array.isArray(bodyText)) {
        return bodyText.reduce((maior, item) => Math.max(maior, Array.isArray(item) ? item.length : 0), 0);
      }

      return 0;
    }

    return 0;
  }

  function extrairTotalParametrosTemplateCompleto(template) {
    const components = Array.isArray(template?.components) ? template.components : [];
    let total = 0;

    components.forEach((component) => {
      const type = String(component?.type || '').toUpperCase();

      if (type === 'HEADER' || type === 'BODY') {
        const qtdPorTexto = contarVariaveisNoTexto(component?.text);
        const qtdPorExample = obterQuantidadePorExample(component, type);
        total += Math.max(qtdPorTexto, qtdPorExample);
        return;
      }

      if (type === 'BUTTONS') {
        const buttons = Array.isArray(component?.buttons) ? component.buttons : [];

        buttons.forEach((button) => {
          const tipoBotao = String(button?.type || '').toUpperCase();

          if (tipoBotao === 'URL') {
            total += contarVariaveisNoTexto(button?.url || button?.text || '');
          }
        });
      }
    });

    return total;
  }

  function analisarExigenciasTemplate(template) {
    const components = Array.isArray(template?.components) ? template.components : [];
    const exigenciasNaoSuportadas = [];

    components.forEach((component) => {
      const type = String(component?.type || '').toUpperCase();

      if (type === 'HEADER') {
        const format = String(component?.format || '').toUpperCase();

        if (format === 'VIDEO' || format === 'DOCUMENT' || format === 'LOCATION') {
          exigenciasNaoSuportadas.push(`HEADER ${format}`);
        }
      }

      if (type === 'BUTTONS') {
        const buttons = Array.isArray(component?.buttons) ? component.buttons : [];

        buttons.forEach((button) => {
          const tipoBotao = String(button?.type || '').toUpperCase();

          if (tipoBotao === 'CATALOG' || tipoBotao === 'FLOW' || tipoBotao === 'MPM') {
            exigenciasNaoSuportadas.push(`BUTTON ${tipoBotao}`);
          }
        });
      }
    });

    return {
      exigenciasNaoSuportadas
    };
  }

  function montarComponentesTemplate(template, paramsInformados) {
    const components = Array.isArray(template?.components) ? template.components : [];
    const componentesEnvio = [];
    let cursor = 0;

    const consumirParams = (qtd) => {
      if (qtd <= 0) return [];
      const slice = paramsInformados.slice(cursor, cursor + qtd);
      cursor += qtd;
      return slice;
    };

    const parseCentavos = (valor) => {
      const texto = String(valor || '').trim();
      if (!texto) return null;
      const normalizado = texto.replace(/\./g, '').replace(',', '.').replace(/[^0-9.\-]/g, '');
      const numero = Number(normalizado);
      if (!Number.isFinite(numero) || numero <= 0) return null;
      return Math.round(numero * 100);
    };

    components.forEach((component) => {
      const type = String(component?.type || '').toUpperCase();

      if (type === 'HEADER') {
        const format = String(component?.format || '').toUpperCase();

        if (format === 'IMAGE') {
          const publicImageUrl = String(consultaTemplatesForm.productImagePublicUrl || '').trim();

          if (!publicImageUrl) {
            return;
          }

          componentesEnvio.push({
            type: 'header',
            parameters: [{
              type: 'image',
              image: {
                link: publicImageUrl
              }
            }]
          });
          return;
        }
      }

      if (type === 'HEADER' || type === 'BODY') {
        const qtdPorTexto = contarVariaveisNoTexto(component?.text);
        const qtdPorExample = obterQuantidadePorExample(component, type);
        const qtd = Math.max(qtdPorTexto, qtdPorExample);
        if (qtd > 0) {
          const tokens = extrairTokensTemplate(component?.text, qtd);
          const valores = consumirParams(qtd);
          componentesEnvio.push({
            type: type.toLowerCase(),
            parameters: valores.map((item, idx) => {
              const token = String(tokens?.[idx] || '').trim();
              const isNumerico = /^\d+$/.test(token);
              const valorNomeado = token && !isNumerico ? obterValorParametroNomeado(token) : '';
              const textoParametro = String(valorNomeado || item || '').trim();

              if (token && !isNumerico) {
                return {
                  type: 'text',
                  text: textoParametro,
                  parameter_name: token
                };
              }

              return { type: 'text', text: textoParametro };
            })
          });
        }
        return;
      }

      if (type === 'BUTTONS') {
        const buttons = Array.isArray(component?.buttons) ? component.buttons : [];

        buttons.forEach((button, index) => {
          const tipoBotao = String(button?.type || '').toUpperCase();

          if (tipoBotao === 'ORDER_DETAILS') {
            const referenceId = String(consultaTemplatesForm.orderReferenceId || '').trim();
            const totalAmountValue = parseCentavos(consultaTemplatesForm.orderTotalAmount);
            const paymentLink = String(consultaTemplatesForm.orderPaymentLink || '').trim();
            const orderType = String(consultaTemplatesForm.orderType || 'digital-goods').trim() || 'digital-goods';

            if (!referenceId || !totalAmountValue || !paymentLink) {
              return;
            }

            componentesEnvio.push({
              type: 'button',
              sub_type: 'order_details',
              index: String(index),
              parameters: [{
                type: 'action',
                action: {
                  order_details: {
                    reference_id: referenceId,
                    type: orderType,
                    payment_type: 'br',
                    payment_settings: [
                      {
                        type: 'payment_link',
                        payment_link: {
                          uri: paymentLink
                        }
                      }
                    ],
                    currency: 'BRL',
                    total_amount: {
                      value: totalAmountValue,
                      offset: 100
                    }
                  }
                }
              }]
            });

            return;
          }

          const qtdPorTexto = contarVariaveisNoTexto(button?.url || button?.text || '');

          if (tipoBotao !== 'URL' || qtdPorTexto <= 0) {
            return;
          }

          const valores = consumirParams(qtdPorTexto);
          const parameters = valores.map((item) => ({ type: 'text', text: item }));
          const componenteBotao = {
            type: 'button',
            sub_type: 'url',
            index: String(index),
            parameters: parameters.map((parametro, parameterIndex) => ({
              ...parametro,
              parameter_name: String(button?.url || '')
                .match(/\{\{\s*([^{}]+?)\s*\}\}/g)?.[parameterIndex]
                ?.replace(/\{|\}|\s/g, '') || undefined
            }))
          };

          componentesEnvio.push(componenteBotao);
        });
      }
    });

    return componentesEnvio;
  }

  async function carregarStatus() {
    try {
      const { data } = await api.get('/integracoes/whatsapp/oficial/status');
      const statusAtual = {
        ativo: Boolean(data?.ativo),
        conectado: Boolean(data?.conectado),
        testeEnvioConcluido: Boolean(data?.testeEnvioConcluido),
        configurado: Boolean(data?.configurado)
      };

      setIntegrationStatus(statusAtual);
      return statusAtual;
    } catch (erro) {
      const statusInativo = { ativo: false, conectado: false, testeEnvioConcluido: false, configurado: false };
      setIntegrationStatus(statusInativo);
      return statusInativo;
    }
  }

  async function carregarConfiguracaoAtual() {
    try {
      const { data } = await api.get('/integracoes/whatsapp/oficial/configuracao');

      setForm((prev) => ({
        ...prev,
        appId: data?.appId || '',
        businessAccountId: data?.businessAccountId || '',
        templatesWabaId: data?.templatesWabaId || '',
        phoneNumberId: data?.phoneNumberId || '',
        systemUserAccessToken: data?.systemUserAccessToken || '',
        webhookVerifyToken: data?.webhookVerifyToken || '',
        webhookPath: data?.webhookPath || prev.webhookPath,
        appSecret: ''
      }));
      setConsultaTemplatesForm((prev) => ({
        ...prev,
        wabaId: prev.wabaId || data?.templatesWabaId || data?.businessAccountId || ''
      }));
    } catch (erro) {
      setMessage({
        type: 'error',
        text: normalizarErro(erro, 'Nao foi possivel carregar a configuracao atual da ativacao.')
      });
    }
  }

  async function salvarConfiguracao() {
    if (!validarFormulario()) return;

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await api.post('/integracoes/whatsapp/oficial/configurar', {
        ...form,
        webhookUrl
      });

      setMessage({ type: 'success', text: 'Configuracao salva com sucesso. Agora clique em Ativar API.' });
    } catch (erro) {
      setMessage({
        type: 'error',
        text: normalizarErro(
          erro,
          'Nao foi possivel salvar. Verifique se o backend possui o endpoint /integracoes/whatsapp/oficial/configurar.'
        )
      });
    } finally {
      setLoading(false);
    }
  }

  async function ativarApiOficial() {
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await api.post('/integracoes/whatsapp/oficial/ativar');
      const status = await carregarStatus();

      if (status?.ativo) {
        await carregarConfiguracaoAtual();
      }

      setMessage({ type: 'success', text: 'API oficial do WhatsApp ativada com sucesso.' });
    } catch (erro) {
      setMessage({
        type: 'error',
        text: normalizarErro(
          erro,
          'Nao foi possivel ativar. Verifique se o backend possui o endpoint /integracoes/whatsapp/oficial/ativar.'
        )
      });
    } finally {
      setLoading(false);
    }
  }

  async function atualizarStatusAtivacao() {
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const status = await carregarStatus();

      if (status?.ativo) {
        await carregarConfiguracaoAtual();
        setMessage({ type: 'success', text: 'Status de ativacao atualizado com sucesso.' });
      } else {
        setMessage({ type: 'error', text: 'API nao esta ativa. Execute a ativacao primeiro.' });
      }
    } catch (erro) {
      setMessage({
        type: 'error',
        text: normalizarErro(erro, 'Nao foi possivel atualizar o status de ativacao.')
      });
    } finally {
      setLoading(false);
    }
  }

  async function salvarConexaoParcial() {
    if (!form.phoneNumberId?.trim() || !form.systemUserAccessToken?.trim()) {
      setMessage({
        type: 'error',
        text: 'Preencha Phone Number ID e System User Access Token para salvar.'
      });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await api.post('/integracoes/whatsapp/oficial/editar-conexao', {
        phoneNumberId: form.phoneNumberId,
        systemUserAccessToken: form.systemUserAccessToken
      });

      await carregarStatus();
      setEditandoConexao(false);
      setMessage({
        type: 'success',
        text: 'Conexao atualizada com sucesso. Clique em Ativar API para reativar a integracao.'
      });
    } catch (erro) {
      setMessage({
        type: 'error',
        text: normalizarErro(erro, 'Nao foi possivel atualizar os dados de conexao.')
      });
    } finally {
      setLoading(false);
    }
  }

  async function buscarTodosTemplates({ salvarWabaNoBanco = false } = {}) {
    const wabaId = String(consultaTemplatesForm.wabaId || '').trim();
    const limit = Math.max(1, Math.min(500, Number(consultaTemplatesForm.limit || 200)));

    if (!wabaId) {
      setConsultaTemplatesMessage({
        type: 'error',
        text: 'Informe WABA ID para buscar templates.'
      });
      return;
    }

    if (!String(form.systemUserAccessToken || '').trim()) {
      setConsultaTemplatesMessage({
        type: 'error',
        text: 'Token nao encontrado na Ativacao. Salve as credenciais antes de buscar templates.'
      });
      return;
    }

    setConsultaTemplatesLoading(true);
    setConsultaTemplatesMessage({ type: '', text: '' });
    setEnvioTemplateMessage({ type: '', text: '' });

    try {
      const { data } = await api.get('/integracoes/whatsapp/oficial/message-templates', {
        params: {
          wabaId,
          limit
        }
      });

      const lista = Array.isArray(data?.templates) ? data.templates : [];

      let selectedTemplateKey = '';
      if (lista.length) {
        const primeiro = lista[0];
        selectedTemplateKey = `${primeiro.name || ''}::${primeiro.language || ''}`;
      }

      setConsultaTemplatesForm((prev) => ({
        ...prev,
        selectedTemplateKey: prev.selectedTemplateKey || selectedTemplateKey
      }));

      if (salvarWabaNoBanco && lista.length) {
        await api.post('/integracoes/whatsapp/oficial/configurar-modelos', {
          templatesWabaId: wabaId
        });

        setForm((prev) => ({
          ...prev,
          templatesWabaId: wabaId
        }));

        setConsultaTemplatesForm((prev) => ({
          ...prev,
          wabaId
        }));
      }

      setConsultaTemplates(lista);
      setConsultaTemplatesMessage({
        type: lista.length ? 'success' : 'error',
        text: lista.length
          ? salvarWabaNoBanco
            ? `Templates encontrados (${lista.length}) e WABA ${wabaId} salvo com sucesso no banco.`
            : `Templates encontrados (todos os status): ${lista.length}.`
          : 'Nenhum template encontrado para as credenciais informadas.'
      });
    } catch (erro) {
      setConsultaTemplates([]);
      setConsultaTemplatesMessage({
        type: 'error',
        text: normalizarErro(erro, 'Nao foi possivel buscar templates.')
      });
    } finally {
      setConsultaTemplatesLoading(false);
    }
  }

  async function carregarTemplatesCacheBanco() {
    try {
      const { data } = await api.get('/integracoes/whatsapp/oficial/templates-aprovados-cache');
      const lista = Array.isArray(data?.templates) ? data.templates : [];

      if (!lista.length) {
        return;
      }

      let selectedTemplateKey = '';
      if (lista.length) {
        const primeiro = lista[0];
        selectedTemplateKey = `${primeiro.name || ''}::${primeiro.language || ''}`;
      }

      setConsultaTemplates(lista);
      setConsultaTemplatesForm((prev) => ({
        ...prev,
        selectedTemplateKey: prev.selectedTemplateKey || selectedTemplateKey,
        wabaId: prev.wabaId || data?.wabaId || form.templatesWabaId || form.businessAccountId || ''
      }));
      setConsultaTemplatesMessage({
        type: 'success',
        text: `Templates aprovados carregados do banco (${lista.length}). Use Buscar Templates para atualizar.`
      });
    } catch (erro) {
      // Cache opcional: nao exibe erro para nao poluir a tela ao abrir.
    }
  }

  async function enviarTemplateSelecionado() {
    const to = String(consultaTemplatesForm.to || '').trim();
    const selectedTemplateKey = String(consultaTemplatesForm.selectedTemplateKey || '').trim();

    if (!to || !selectedTemplateKey) {
      setEnvioTemplateMessage({
        type: 'error',
        text: 'Selecione um template e informe o numero destino para enviar.'
      });
      return;
    }

    const [templateName, languageCode] = selectedTemplateKey.split('::');
    if (!templateName || !languageCode) {
      setEnvioTemplateMessage({
        type: 'error',
        text: 'Template selecionado invalido. Recarregue a lista e tente novamente.'
      });
      return;
    }

    const templateSelecionado = consultaTemplates.find((item) => {
      const key = `${String(item?.name || '')}::${String(item?.language || '')}`;
      return key === selectedTemplateKey;
    });

    const analise = analisarExigenciasTemplate(templateSelecionado);
    if (analise.exigenciasNaoSuportadas.length) {
      setEnvioTemplateMessage({
        type: 'error',
        text: `Template exige componente nao suportado neste envio rapido: ${analise.exigenciasNaoSuportadas.join(', ')}. Para este template, use outro modelo sem esse botao ou implemente payload dedicado no backend.`
      });
      return;
    }

    const buttonsComponent = Array.isArray(templateSelecionado?.components)
      ? templateSelecionado.components.find((item) => String(item?.type || '').toUpperCase() === 'BUTTONS')
      : null;
    const headerComponent = Array.isArray(templateSelecionado?.components)
      ? templateSelecionado.components.find((item) => String(item?.type || '').toUpperCase() === 'HEADER')
      : null;
    const hasHeaderImage = String(headerComponent?.format || '').toUpperCase() === 'IMAGE';
    const hasOrderDetailsButton = Array.isArray(buttonsComponent?.buttons)
      && buttonsComponent.buttons.some((button) => String(button?.type || '').toUpperCase() === 'ORDER_DETAILS');

    if (hasHeaderImage && !String(consultaTemplatesForm.productImagePublicUrl || '').trim()) {
      setEnvioTemplateMessage({
        type: 'error',
        text: 'Este template exige HEADER de imagem. Informe a URL publica da imagem do produto para envio.'
      });
      return;
    }

    if (hasOrderDetailsButton) {
      const referenceId = String(consultaTemplatesForm.orderReferenceId || '').trim();
      const totalAmount = String(consultaTemplatesForm.orderTotalAmount || '').trim();
      const paymentLink = String(consultaTemplatesForm.orderPaymentLink || '').trim();

      if (!referenceId || !totalAmount || !paymentLink) {
        setEnvioTemplateMessage({
          type: 'error',
          text: 'Para templates com ORDER_DETAILS, preencha Referencia do pedido, Valor total e Link de pagamento.'
        });
        return;
      }
    }

    const totalEsperado = extrairTotalParametrosTemplateCompleto(templateSelecionado);
    const paramsInformados = montarParametrosParaEnvio(totalEsperado, hasOrderDetailsButton);

    if (totalEsperado > 0 && paramsInformados.length !== totalEsperado) {
      setEnvioTemplateMessage({
        type: 'error',
        text: `Esse template exige ${totalEsperado} parametro(s). Foram montados ${paramsInformados.length}. Complete em Parametros do template (separados por |).`
      });
      return;
    }

    const components = montarComponentesTemplate(templateSelecionado, paramsInformados);

    setEnvioTemplateLoading(true);
    setEnvioTemplateMessage({ type: '', text: '' });

    try {
      const endpoint = integrationStatus.testeEnvioConcluido
        ? '/integracoes/whatsapp/oficial/enviar-template'
        : '/integracoes/whatsapp/oficial/teste-template';

      const { data } = await api.post(endpoint, {
        to,
        templateName,
        languageCode,
        components
      });

      if (!integrationStatus.testeEnvioConcluido) {
        await carregarStatus();
      }

      setEnvioTemplateMessage({
        type: 'success',
        text: data?.message || 'Envio realizado com sucesso.'
      });
    } catch (erro) {
      setEnvioTemplateMessage({
        type: 'error',
        text: normalizarErro(erro, 'Nao foi possivel enviar o template selecionado.')
      });
    } finally {
      setEnvioTemplateLoading(false);
    }
  }

  useEffect(() => {
    if (!showWhatsappModal || activeModalTab !== 'buscar_templates') {
      return;
    }

    if (consultaTemplates.length > 0) {
      return;
    }

    carregarTemplatesCacheBanco();
  }, [showWhatsappModal, activeModalTab, form.templatesWabaId, form.businessAccountId]);

  useEffect(() => {
    try {
      const imagemPublica = String(consultaTemplatesForm.productImagePublicUrl || '').trim();

      if (imagemPublica) {
        localStorage.setItem(PRODUTO_IMAGEM_PUBLICA_CACHE_KEY, imagemPublica);
      } else {
        localStorage.removeItem(PRODUTO_IMAGEM_PUBLICA_CACHE_KEY);
      }
    } catch (erro) {
      // Persistencia opcional: ignora falha de armazenamento.
    }
  }, [consultaTemplatesForm.productImagePublicUrl]);

  const templateSelecionadoConsulta = consultaTemplates.find((item) => {
    const key = `${String(item?.name || '')}::${String(item?.language || '')}`;
    return key === String(consultaTemplatesForm.selectedTemplateKey || '');
  });
  const quantidadeParametrosEsperada = extrairTotalParametrosTemplateCompleto(templateSelecionadoConsulta);

  // ----------------------------------------------------------------------------------------------
  return (
    <S.body>
      <Header playLogo={false} />

      <BarraLateral
        customButtons={[
          { key: 'ativacao', label: 'Ativacao', onClick: () => abrirModalNaAba('ativacao') },
          { key: 'buscar_templates', label: 'Buscar Templates', onClick: () => abrirModalNaAba('buscar_templates') },
          { key: 'meta_setup', label: 'Meta Setup', to: '/autoboox/meta-setup' },
        ]}
        activeKey={activeModalTab}
      />

      <S.bodyMeio>
        <S.imagem >
          <img src={logo_bg} alt='Autoboox Beneficios' />
        </S.imagem>

        <S.actions>
          <button type='button' onClick={handleOpenModal}>
            Conectar API Oficial WhatsApp
          </button>
        </S.actions>
      </S.bodyMeio>

      <div style={{color:"white", fontWeight: "100", fontSize: 'clamp(10px, 3vw, 1.5vw)', position: "fixed", bottom: "60px"}}>
        Autobox Beneficios intermedia atendimentos para 
        <span style={{color:"#01CA55"}}> Associação Mais Apoio</span>
      </div>

      {showWhatsappModal && (
        <S.modalOverlay $classic={activeModalTab === 'ativacao'}>
          <S.modalContainer $classic={activeModalTab === 'ativacao'}>
            <S.modalHeader>
              <h3>{activeModalTab === 'buscar_templates' ? 'Templates Oficiais WhatsApp' : 'Conexao com API Oficial do WhatsApp'}</h3>
              <button type='button' onClick={handleCloseModal}>X</button>
            </S.modalHeader>

            {activeModalTab === 'ativacao' && (
              <>
                <S.wizardContainer>
                  <S.wizardStep status={etapa2Liberada ? 'done' : 'active'}>
                    <S.wizardCircle status={etapa2Liberada ? 'done' : 'active'}>1</S.wizardCircle>
                    <div>
                      <strong>Configuracao Inicial</strong>
                      <span>Salvar credenciais e ativar conexao</span>
                    </div>
                  </S.wizardStep>

                  <S.wizardLine active={etapa2Liberada} />

                  <S.wizardStep status={etapa2Liberada ? 'active' : 'pending'}>
                    <S.wizardCircle status={etapa2Liberada ? 'active' : 'pending'}>2</S.wizardCircle>
                    <div>
                      <strong>Teste de Envio</strong>
                      <span>Selecionar template e enviar teste</span>
                    </div>
                  </S.wizardStep>
                </S.wizardContainer>

                <S.modalStatus>
                  <div>
                    Status da Integracao:{' '}
                    <strong>{integrationStatus.ativo ? 'Ativa' : 'Inativa'}</strong>
                  </div>
                  <div>
                    Conexao:{' '}
                    <strong>{integrationStatus.conectado ? 'Conectada' : 'Nao conectada'}</strong>
                  </div>
                </S.modalStatus>
              </>
            )}

            <S.modalContent>
              {activeModalTab === 'ativacao' && (
                <S.infoBox>
                  <p>Para ativar a API oficial da Meta, preencha as credenciais abaixo.</p>
                  <p>Webhook para cadastrar no app da Meta:</p>
                  <span>{webhookUrl}</span>
                </S.infoBox>
              )}

              {activeModalTab === 'ativacao' && (
                <Ativacao
                  integrationStatus={integrationStatus}
                  editandoConexao={editandoConexao}
                  loading={loading}
                  form={form}
                  handleChangeField={handleChangeField}
                  gerarToken={gerarToken}
                  setEditandoConexao={setEditandoConexao}
                  salvarConexaoParcial={salvarConexaoParcial}
                  atualizarStatusAtivacao={atualizarStatusAtivacao}
                />
              )}

              {activeModalTab === 'buscar_templates' && (
                <BuscarTemplates
                  loading={loading}
                  consultaTemplatesLoading={consultaTemplatesLoading}
                  consultaTemplatesForm={consultaTemplatesForm}
                  consultaTemplatesMessage={consultaTemplatesMessage}
                  consultaTemplates={consultaTemplates}
                  envioTemplateLoading={envioTemplateLoading}
                  envioTemplateMessage={envioTemplateMessage}
                  tokenAtivacaoDisponivel={Boolean(String(form.systemUserAccessToken || '').trim())}
                  testeEnvioConcluido={integrationStatus.testeEnvioConcluido}
                  wabaIdSalvo={form.templatesWabaId}
                  quantidadeParametrosEsperada={quantidadeParametrosEsperada}
                  handleConsultaTemplatesField={handleConsultaTemplatesField}
                  buscarTodosTemplates={() => buscarTodosTemplates({ salvarWabaNoBanco: true })}
                  enviarTemplateSelecionado={enviarTemplateSelecionado}
                />
              )}

              {message.text && (
                <S.feedback type={message.type}>{message.text}</S.feedback>
              )}
            </S.modalContent>

            <S.modalFooter>
              <button type='button' className='ghost' onClick={handleCloseModal}>Fechar</button>
              {activeModalTab === 'ativacao' && !integrationStatus.ativo && (
                <button type='button' onClick={salvarConfiguracao} disabled={loading}>
                  {loading ? 'Processando...' : 'Salvar Configuracao'}
                </button>
              )}
              {activeModalTab === 'ativacao' && (
                <button type='button' className='primary' onClick={ativarApiOficial} disabled={loading}>
                  {loading ? 'Processando...' : 'Ativar API'}
                </button>
              )}
            </S.modalFooter>
          </S.modalContainer>
        </S.modalOverlay>
      )}

      <Footer />
    </S.body>
  )
}